/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type DownSavingStatusUpdateRequest = {
    status: DownSavingStatusUpdateRequest.status;
};
export namespace DownSavingStatusUpdateRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        CLOSED = 'CLOSED',
        DATA_LOSS = 'DATA_LOSS',
        LINE_BLOCKED_DEVICE_RECEIVE = 'LINE_BLOCKED_DEVICE_RECEIVE',
        LINE_BLOCKED_DEVICE_NOT_RECEIVE = 'LINE_BLOCKED_DEVICE_NOT_RECEIVE',
        CANCELLED = 'CANCELLED',
        WITHDRAWN = 'WITHDRAWN',
    }
}

